import React, { FC, useCallback, useContext, useState } from 'react'

import { useMutation } from '@apollo/client'
import { useForm } from 'react-hook-form'

import { AppContext, APPLY_TIP_VARIANT } from 'Const'
import { Cart } from 'Types'
import { convertFormattedToFloat, noty } from 'Utils'

import TipVariantBtn from './TipVariantBtn'

const Tips: FC = () => {
  const { shop, cart, account } = useContext(AppContext)

  const [tipVariantId, setTipVariantId] = useState(cart.appliedTipVariant?.tipVariantId)

  const [applyTipVariant] = useMutation<{ applyTipVariant: { cart: Cart } }>(APPLY_TIP_VARIANT)

  const { register, handleSubmit, setValue } = useForm()

  const handleApplyTipVariant = useCallback(
    ({ amount, id = null }) => {
      const convertedAmount = convertFormattedToFloat(amount)
      if (isNaN(convertedAmount)) {
        noty('Incorrect tip value')
      } else {
        void applyTipVariant({ variables: { amount: convertedAmount, tipVariantId: id } }).then(({ data }) => {
          setTipVariantId(id)
          setValue('amount', data?.applyTipVariant.cart.appliedTipVariant?.amountFormatted)
        })
      }
    },
    [applyTipVariant, setValue],
  )

  return (
    <div className="tips">
      <h2 className="checkout-order__products-title / h6">
        {/* HARDCODE for accountId: 488, KitchenHub */}
        {account.id === '488'
          ? 'Kitchen Hub team tips'
          : cart.fulfillment?.driverTipVariants?.length
          ? 'Add restaurant tip'
          : 'Add tip'}
      </h2>
      <input defaultValue={tipVariantId} name="tipVariantId" type="hidden" />
      <div className="tips__buttons">
        {shop.tipVariants.map((tipVariant) => (
          <TipVariantBtn
            key={tipVariant.id}
            applyTipVariant={handleApplyTipVariant}
            tipVariant={tipVariant}
            tipVariantId={tipVariantId}
          />
        ))}
      </div>

      {shop.checkoutSetting.enableCustomTips ? (
        <form onSubmit={handleSubmit(handleApplyTipVariant)}>
          <div className="input-group">
            <input
              ref={register}
              required
              className="form-control"
              defaultValue={cart.appliedTipVariant?.amountFormatted}
              name="amount"
              placeholder="Custom amount"
              type="text"
            />
            <div className="input-group-append">
              <button className="btn btn-accent / py-1 / text-uppercase" type="submit">
                Apply
              </button>
            </div>
          </div>
        </form>
      ) : null}
    </div>
  )
}

export default Tips
